'use strict';

const jQuery = require('jquery');

const Translator = require('./../../../core/translator');

let callback = function($content) {
    let $current = $content instanceof jQuery ? $content : jQuery(this);
    $current.html(Translator.translate($current.attr('data-cloud-trans')));
};

module.exports.init = function() {
    jQuery('[data-cloud-trans]').each(callback);
};

module.exports.applyOnChange = function(content) {
    if (!content.$) {
        return;
    }

    if (content.$.attr('data-cloud-trans')) {
        callback(content.$);
    }

    content.$.find('[data-cloud-trans]').each(callback);
};
